import { Component, OnDestroy, OnInit } from '@angular/core';
import { AmplitudeService } from '@inyova/inyova-shared';
import { Customer } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import * as AppRootActions from '@app/app.actions';
import * as fromAppRoot from '@app/app.reducers';

@Component({
  selector: 'app-green-survey',
  templateUrl: './green-survey.component.html',
  styleUrls: ['./green-survey.component.scss'],
  standalone: false
})
export class GreenSurveyComponent implements OnInit, OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  customer: Customer;
  appLocation: string;

  constructor(
    private store: Store,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.store.pipe(select(fromAppRoot.selectCustomer), takeUntil(this.onDestroy$)).subscribe((customer) => {
      this.customer = customer;
      this.appLocation = customer.app_location;
    });
  }

  onSurveySubmit(data: { score?: number; annual_income?: string; net_worth?: string }) {
    this.amplitudeService.trackEvent('Greenness Score Submitted', {
      customer_greenness_score: data.score,
      placement: 'onboarding'
    });
    this.store.dispatch(AppRootActions.submitOnboardingGreennessSurvey({ data: { greenness_score: data.score } }));
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
